import React from 'react'
import { buildQueryString } from '../utils/queryString'
import { CALL_API } from '../middleware/api'
import { adminHost, getHeaders } from '../utils'

// CANDIDATE GENERAL INFORMATION
export const CANDIDATE_LIST_REQUEST = 'CANDIDATE_LIST_REQUEST'
export const CANDIDATE_LIST_SUCCESS = 'CANDIDATE_LIST_SUCCESS'
export const CANDIDATE_LIST_FAILURE = 'CANDIDATE_LIST_FAILURE'

// CANDIDATE UPDATE DATA
export const UPDATE_CANDIDATE_FILTERS = 'UPDATE_CANDIDATE_FILTERS'

// CANDIDATE DELETE DATA
export const CANDIDATE_CHANGE_STATUS_REQUEST =
  'CANDIDATE_CHANGE_STATUS_REQUEST'
export const CANDIDATE_CHANGE_STATUS_SUCCESS =
  'CANDIDATE_CHANGE_STATUS_SUCCESS'
export const CANDIDATE_CHANGE_STATUS_FAILURE =
  'CANDIDATE_CHANGE_STATUS_FAILURE'

export const UPDATE_CANDIDATE_DETAIL_FILTERS =
  'UPDATE_CANDIDATE_DETAIL_FILTERS'
export const CANDIDATE_DETAIL_REQUEST = 'CANDIDATE_DETAIL_REQUEST'
export const CANDIDATE_DETAIL_SUCCESS = 'CANDIDATE_DETAIL_SUCCESS'
export const CANDIDATE_DETAIL_FAILURE = 'CANDIDATE_DETAIL_FAILURE'

// CANDIDATE DOCUMENT INFORMATION
export const CANDIDATE_DOCS_REQUEST = 'CANDIDATE_DOCS_REQUEST'
export const CANDIDATE_DOCS_SUCCESS = 'CANDIDATE_DOCS_SUCCESS'
export const CANDIDATE_DOCS_FAILURE = 'CANDIDATE_DOCS_FAILURE'

export const SELECT_CANDIDATE = 'SELECT_CANDIDATE'
export const SHOW_MESSAGE = 'SHOW_MESSAGE'
export const HIDE_MESSAGE = 'HIDE_MESSAGE'
export const RESET_CANDIDATE = 'RESET_CANDIDATE'

export const CANDIDATE_RELEASE_DEVICE_REQUEST =
  'CANDIDATE_RELEASE_DEVICE_REQUEST'
export const CANDIDATE_RELEASE_DEVICE_SUCCESS =
  'CANDIDATE_RELEASE_DEVICE_SUCCESS'
export const CANDIDATE_RELEASE_DEVICE_FAILURE =
  'CANDIDATE_RELEASE_DEVICE_FAILURE'

export const FORWARD_CANDIDATE_EMAIL_REQUEST =
  'FORWARD_CANDIDATE_EMAIL_REQUEST'
export const FORWARD_CANDIDATE_EMAIL_SUCCESS =
  'FORWARD_CANDIDATE_EMAIL_SUCCESS'
export const FORWARD_CANDIDATE_EMAIL_FAILURE =
  'FORWARD_CANDIDATE_EMAIL_FAILURE'

export function candidateList(params = {}) {
  let url = 'courier_candidate/'
  const qs = buildQueryString(params)
  if (qs) url += `?${qs}`

  return {
    [CALL_API]: {
      method: 'GET',
      localAPI: false,
      endpoint: url,
      authenticated: true,
      extra: params,
      types: [
        CANDIDATE_LIST_REQUEST,
        CANDIDATE_LIST_SUCCESS,
        CANDIDATE_LIST_FAILURE
      ]
    }
  }
}

export function updateCandidateFilters(data) {
  return dispatch => {
    const action = {
      type: UPDATE_CANDIDATE_FILTERS,
      data
    }
    dispatch(action)
  }
}

export function updateCandidateDetailFilters(data) {
  return dispatch => {
    const action = {
      type: UPDATE_CANDIDATE_DETAIL_FILTERS,
      data
    }
    dispatch(action)
  }
}

export function selectCandidate(obj) {
  return dispatch => {
    const action = {
      type: SELECT_CANDIDATE,
      data: obj
    }
    dispatch(action)
  }
}

export function changeStatusCandidate(data) {
  return {
    [CALL_API]: {
      method: 'PATCH',
      endpoint: `courier_candidate/${data.id}/`,
      authenticated: true,
      data,
      types: [
        CANDIDATE_CHANGE_STATUS_REQUEST,
        CANDIDATE_CHANGE_STATUS_SUCCESS,
        CANDIDATE_CHANGE_STATUS_FAILURE
      ]
    }
  }
}

export function getCandidateData(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `courier_candidate/${id}/`,
      authenticated: true,
      types: [
        CANDIDATE_DETAIL_REQUEST,
        CANDIDATE_DETAIL_SUCCESS,
        CANDIDATE_DETAIL_FAILURE
      ]
    }
  }
}

export function getCandidateDocs(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `courier_candidate/${id}/documents/`,
      authenticated: true,
      types: [
        CANDIDATE_DOCS_REQUEST,
        CANDIDATE_DOCS_SUCCESS,
        CANDIDATE_DOCS_FAILURE
      ]
    }
  }
}

export const uploadCandidateDocument = (
  candidateId,
  files,
  types,
  sides,
  onProgress
) => {
  return async () => {
    try {
      const headers = getHeaders()
      delete headers['Content-Type'] // Necesario para FormData

      const formData = new FormData()

      // Si es un array de archivos (para múltiples lados)
      if (Array.isArray(files)) {
        files.forEach((file, index) => {
          formData.append('documents', file)
          formData.append('types', types[index] || types) // Usar array o valor único
          formData.append('sides', sides[index] || '') // Usar array o valor único
        })
      } else {
        // Para un solo archivo (PDF o imagen sin lados)
        formData.append('documents', files)
        formData.append('types', types)
        formData.append('sides', sides || '')
      }

      // Crear una instancia de XMLHttpRequest para soportar progreso
      const xhr = new XMLHttpRequest()

      return new Promise((resolve, reject) => {
        xhr.upload.onprogress = event => {
          if (event.lengthComputable && onProgress) {
            const progress = Math.round((event.loaded * 100) / event.total)
            onProgress(progress)
          }
        }

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const response = JSON.parse(xhr.responseText)
              resolve(response)
            } catch (error) {
              console.error('Error parsing response:', error)
              reject(new Error('Error al procesar la respuesta del servidor'))
            }
          } else {
            let errorMessage = 'Error al subir el documento'
            try {
              const errorData = JSON.parse(xhr.responseText)
              errorMessage =
                errorData.message || errorData.error || errorMessage
            } catch (e) {
              console.error('Error parsing error response:', e)
            }
            reject(new Error(errorMessage))
          }
        }

        xhr.onerror = () => {
          reject(new Error('Error de conexión al subir el documento'))
        }

        xhr.open(
          'POST',
          `${adminHost}/courier_candidate/${candidateId}/documents/bulk-upload/`,
          true
        )

        // Agregar headers manualmente
        Object.entries(headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value)
        })

        xhr.send(formData)
      })
    } catch (error) {
      console.error('Error uploading document:', error)
      throw error
    }
  }
}

export function candidateReleaseDevice(id) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `courier_candidate/${id}/release_device/`,
      authenticated: true,
      localAPI: false,
      types: [
        CANDIDATE_RELEASE_DEVICE_REQUEST,
        CANDIDATE_RELEASE_DEVICE_SUCCESS,
        CANDIDATE_RELEASE_DEVICE_FAILURE
      ]
    }
  }
}

export function forwardCandidateEmail(id) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `courier_candidate/${id}/notify_success/`,
      authenticated: true,
      localAPI: false,
      types: [
        FORWARD_CANDIDATE_EMAIL_REQUEST,
        FORWARD_CANDIDATE_EMAIL_SUCCESS,
        FORWARD_CANDIDATE_EMAIL_FAILURE
      ]
    }
  }
}
